// extracted by mini-css-extract-plugin
export default {"Button":"TypeButton_Button__mQO7D","Small":"TypeButton_Small__7Z4pO","Unavailable":"TypeButton_Unavailable__a3pfa"};